import React, { Component, Fragment } from 'react'
import { Container,Row,Col, Modal,Button } from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faVideoSlash} from '@fortawesome/free-solid-svg-icons'
import 'video-react/dist/video-react.css';
import { Player, BigPlayButton } from 'video-react';

import axios from 'axios';
import RestClient from '../../RestAPI/RestClient';
import AppUrl  from '../../RestAPI/AppUrl';


export class Video extends Component {

    constructor(){
        super();
        this.state= {
            videonewDescription:""
        }
         this.state={
            show:false
        }
    }

componentDidMount(){
    RestClient.GetRequest(AppUrl.Videopart).then(result=>{
        this.setState({videonewDescription:result[1]['videoDescription']});

    }).catch(error=>{
      this.setState({videonewDescription:"????"})
    });

}


    

    modalClose=()=>this.setState({show:false})
    modalOpen=()=>this.setState({show:true})





/*{this.state.videonewDescription}   p tag er moddhe boshay dibo */ 

  render() {
    return (
      <Fragment>
        
        <Container fluid={true} className='text-center'>
        
             <h1 className='h1Tag'>Our Events Clips</h1>
            <div className='bottom'></div>
            <Row>
                <Col lg={6} md={6} sm={12} className='videoText'>
               <p className='pTag text-justify'>{this.state.videonewDescription} </p>
                </Col>


                <Col lg={6} md={6} sm={12} className='videoCard'>
              <FontAwesomeIcon onClick={this.modalOpen} className="iconProject" icon={faVideoSlash}></FontAwesomeIcon>
                </Col>
            </Row>

        </Container>
       
    
    
      <Modal  show={this.state.show} onHide={this.modalClose}>
       <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>

        <Modal.Body>
           <Player src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4">
      <BigPlayButton position="center" />
    </Player>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.modalClose}>Close</Button>
          
        </Modal.Footer>
      </Modal>
     
   
      </Fragment>
    )
  }
}

export default Video
